import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@app/core/core.module';
import { ThemeModule } from '@app/theme/theme.module';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import {
	NbDatepickerModule,
	NbMenuModule,
	NbSidebarModule,
	NbToastrModule
} from '@nebular/theme';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { it } from 'date-fns/locale';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { filtersValueReducer } from './store/reducer';

registerLocaleData(localeIt);

export const AppModule = (appConfig: typeof AppConfig) => {
	@NgModule({
		declarations: [AppComponent],
		imports: [
			BrowserModule,
			BrowserAnimationsModule,
			AppRoutingModule,
			NbSidebarModule.forRoot(),
			NbDatepickerModule.forRoot(),
			NbDateFnsDateModule.forRoot({
				format: appConfig.dateFns.format,
				parseOptions: { locale: it },
				formatOptions: { locale: it }
			}),
			NbMenuModule.forRoot(),
			NbToastrModule.forRoot(appConfig.toastr),
			CoreModule.forRoot(appConfig),
			ThemeModule.forRoot(),
			StoreModule.forRoot({ filters: filtersValueReducer }),
			StoreDevtoolsModule.instrument({
				maxAge: 25,
				logOnly: !isDevMode(),
				autoPause: true,
				trace: false,
				traceLimit: 75
			})
		],
		bootstrap: [AppComponent]
	})
	class Module {}
	return Module;
};
